module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_02_Trail-02-ed4d61db41711d175451f8cc44bd579d.png";